/**
 * api/ideas.js — Ideas CRUD
 *
 * GET    /api/ideas
 * POST   /api/ideas
 * PUT    /api/ideas/:id
 * DELETE /api/ideas/:id
 */

import client from './client';

export const ideasApi = {

  async getAll(params = {}) {
    const { data } = await client.get('/ideas', { params });
    // Laravel apiResource returns { data: [...] }
    return data.data ?? data;
  },

  async create(payload) {
    const { data } = await client.post('/ideas', payload);
    return data.data ?? data;
  },

  async update(id, payload) {
    const { data } = await client.put(`/ideas/${id}`, payload);
    return data.data ?? data;
  },

  async remove(id) {
    await client.delete(`/ideas/${id}`);
  },
};
